import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IKeepInTouchJobConfiguration } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UpdateVariables {
	id: string;
	request: Partial<IKeepInTouchJobConfiguration>;
}

export const useUpdateKeepInTouchConfiguration = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IKeepInTouchJobConfiguration) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ id, request }: UpdateVariables) => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchJobConfiguration>(
				`KeepInTouchJobConfiguration/${id}`,
				'PUT',
				request
			);
		},
		onError,
		onSuccess,
	});
};
